var _a;
export default class Constants {
    static get UserMetadata() {
        return this.userMetadata;
    }
    static set UserMetadata(userMetadata) {
        this.userMetadata = userMetadata;
        if (this.userMetadata) {
            document.cookie = `token=${userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.token}; max-age=${this.cookieLifetime}; `;
            document.cookie = `userId=${userMetadata === null || userMetadata === void 0 ? void 0 : userMetadata.userId}; max-age=${this.cookieLifetime}; `;
        }
    }
    static get LastPage() {
        return this.lastPage;
    }
    static set LastPage(value) {
        if (!value ||
            value === this.routes.signin ||
            value === this.routes.signup ||
            value === this.routes.sprint ||
            value === this.routes.audio)
            return;
        if (Object.values(this.routes).includes(value)) {
            this.lastPage = `/${this.routes[value]}`;
        }
        else {
            this.lastPage = `/${this.routes.main}`;
        }
    }
}
_a = Constants;
Constants.serverURL = 'https://my-learnwords.herokuapp.com';
Constants.cookieLifetime = 14400;
Constants.userMetadata = /token/.test(document.cookie)
    ? {
        token: document.cookie
            .split('; ')
            .filter((el) => el.startsWith('token'))
            .join()
            .split('=')[1],
        userId: document.cookie
            .split('; ')
            .filter((el) => el.startsWith('userId'))
            .join()
            .split('=')[1],
    }
    : null;
Constants.routes = {
    main: '',
    ebook: 'ebook',
    games: 'games',
    sprint: 'sprint',
    audio: 'audio',
    statistics: 'statistics',
    about: 'about',
    signin: 'signin',
    signup: 'signup',
};
Constants.appName = 'RS-Lang';
Constants.lastPage = _a.routes.main;
